<template>
  <div class="main">
    <module-title :module-title="moduleTitle"/>
    <!-- <div -->
      <!-- class="quite" -->
      <!-- @click="showAlert(getElseIcons)"> -->
      <!-- <div class="quite-item"> -->
        <!-- <span class="quite-text">快速问律师</span> -->
        <!-- <span class="quite-tag">30秒极速接听</span> -->
      <!-- </div> -->
      <!-- <span class="quite-img"><img -->
        <!-- class="ljb-size100" -->
        <!-- src="https://cdn.51ljb.cn/ljb-icon_gray_phone.png"></span> -->
    <!-- </div> -->
    <!-- <van-swipe @change="onChange" class="van-swipe-change">
      <van-swipe-item class="van-swipe-item-field"> -->
        <ul class="field flex">
          <li v-for="(item,key) in getIcons" :key="key" class="item" @click="iconItemClick(item,key)">
            <img :src="item.iconUrl" class="imgs">
            <p class="name ljb-md-text">{{ item.customName }}</p>
            <img v-if="item.fieldCode === '24'" class="newlogo" src="https://cdn.51ljb.cn/ljb_icon_new_logo.png" alt="">
          </li>
        </ul>
      <!-- </van-swipe-item>
      <van-swipe-item class="van-swipe-item-field">
        <ul class="field flex">
          <li v-for="(item,key) in getIcons" :key="key" v-if="item.fieldCode === '7'" class="item" @click="iconItemClick(item,key)">
            <img v-if="item.fieldCode === '7'" :src="item.iconUrl" class="imgs">
            <p v-if="item.fieldCode === '7'" class="name ljb-md-text">{{ item.customName }}</p>
          </li>
        </ul>
      </van-swipe-item>
      <div class="custom-indicator" slot="indicator">
        <div class="indicators" :class="current+1 === 1 ? 'indicators-active':''"></div>
        <div class="indicators" :class="current+1 === 2 ? 'indicators-active':''"></div>
      </div>
    </van-swipe> -->
    <popup-consulting
      v-model="isShowAlert"
      :title="checkItem.customName"
      :text="checkItem.name"
      :type-list="checkItem.subItem"
      @btnClick="commitOrder"/>
  </div>

  <!--<ul class="flex ">-->
  <!--<li-->
  <!--v-for="(item,index) in getIcons"-->
  <!--:key="index"-->
  <!--class="item double_center"-->
  <!--@click="iconItemClick(item,index)">-->
  <!--<img-->
  <!--:src="item.img"-->
  <!--class="icon">-->
  <!--<div class="ljb-title text">{{ item.name }}</div>-->
  <!--</li>-->
  <!--<popup-consulting-->
  <!--v-model="isShowAlert"-->
  <!--:title="checkItem.name"-->
  <!--:text="checkItem.name"-->
  <!--:type-list="checkItem.subItem"/>-->
  <!--</ul>-->
</template>

<script>
import {mapGetters} from 'vuex'
import PopupConsulting from '@/components/popup/consulting/PopupConsulting'
import { Swipe, SwipeItem } from 'vant';
import Vue from 'vue'
import ModuleTitle from '@/components/title/ModuleTitleDhzx'

Vue.use(Swipe).use(SwipeItem);
export default {
  name: 'ListField',
  components: {PopupConsulting, ModuleTitle},
  data () {
    return {
      moduleTitle: {
        title: '电话咨询',
        text: '点击领域 问专家'
      },
      isShowAlert: false,
      checkItem: {},
      price: '0',
      current: 0,
    }
  },
  computed: {
    ...mapGetters('Channel', ['getChannelData']),
    ...mapGetters('User', [
      'getUserInfo',
      'getUserCenter',
      'getShowLogin'
    ]),
    getElseIcons () {
      if (this.getIcons && this.getIcons.length > 0) {
        return this.getIcons[this.getIcons.length - 1]
      }
    },
    getIcons () {
      // return this.getChannelData.fields
      return [
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_zqzw2.png', fieldCode: '4', customName: '债权债务' },
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_hyjc2.png', fieldCode: '2', customName: '婚姻家庭' },
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_fcwy2.png', fieldCode: '3', customName: '房产物业' },
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_ldrs2.png', fieldCode: '5', customName: '劳动人事' },
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_jtcx2.png', fieldCode: '1', customName: '交通出行' },
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_xfwq2.png', fieldCode: '6', customName: '消费维权' },
        // { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_yljf2.png', fieldCode: '9', customName: '医疗纠纷' },
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_fswt2.png', fieldCode: '24', customName: '税务咨询' },
        { iconUrl: 'https://cdn.51ljb.cn/ljb_icons_jg_qtwt2.png', fieldCode: '7', customName: '其他问题' },
      ]
    }
  },
  watch: {
    getUserCenter () {
      this.checkPrice()
    }
  },
  mounted () {
    console.log('lsit field mounted')
    this.checkPrice()
  },
  methods: {
    iconItemClick (item) {
      // this.$router.push({path: 'SubTel', query: {id: item.fieldCode}})
      // checkCanGoRouter(item.url)

      if (this.getChannelData.mode === this.$dataResource.mode.pop) {
        this.showAlert(item)
        return
      }
      this.$router.push({name: 'SubTel', params: {id: item.fieldCode}})
      // this.$emit('onItemClick', item)
    },
    onChange (index) {
      console.log(index)
      this.current = index;
    },
    commitOrder: function () {
      if (!this.getUserInfo || this.getUserInfo === '') {
        this.$store.commit('User/setShowLogin', true)
        this.isShowAlert = false
        return
      }
      this.createOrder()
    },
    // 创建电话订单
    createOrder: function () {
      this.$post.createTelOrder({
        consultField: this.checkItem.fieldCode
      }).then((res) => {
        if (res.data.orderId) {
          this.$store.commit('WebSocket/setOrderLawyer', null)
          this.$router.push({name: 'PhoneWaiting', params: {id: res.data.orderId}})
        } else {
          this.$toast('您有未支付订单，请及时支付')
          setTimeout(() => {
            this.$router.push({name: 'TelDetail', params: {id: res.data.unpaidOrderId}})
          }, 1500)
        }
      })
    },
    // 创建电话订单
    checkPrice: function () {
      console.log('checkPrice')
      this.$post.productPrice({
        productCode: 'SC17001',
        field: '7'
      }).then((res) => {
        console.log('res', res)
        if (res && res.data) {
          this.price = res.data.needPayAmount
        } else {
          this.price = this.getChannelData.price
        }
      })
    },
    showAlert (item) {
      this.checkItem = item
      this.isShowAlert = true
      if (this.price > 0) {
        if (this.getChannelData.payType === this.$dataResource.chargeType.byTime) {
          this.checkItem.name = '特惠：' + this.price + '元/分钟（少于1分钟免费）'
        } else {
          this.checkItem.name = '特惠：' + this.price + '元/次（少于1分钟免费）'
        }
      } else {
        this.checkItem.name = '会员免费'
      }
      // if (this.getUserCenter && this.getUserCenter.isMember === 1) {
      //   this.checkItem.name = '会员免费'
      // } else {
      //
      // }
    }
  }
}
</script>

<style scoped lang="scss">
  .main{
    padding:0 $padding;
    border-bottom: 1px solid #F0F0F0;
    padding-bottom: 20px;
  }
  .field{
    flex-wrap: wrap;
  }
  .item{
    text-align: center;
    margin-top: 20px;
    position: relative;
    width: 25%;
    .imgs{
      width: 30px;
      height: 30px;
    }
    .name{
      margin-top: 9px;
    }
    .newlogo{
      width: 25px;
      position: absolute;
      right: 8px;
      top: -8px;
    }
  }
  .quite{
    padding: 0 9px;
    height: 54px;
    align-items: center;
    border-radius: 5px;
    background-color: #f7f7f7;
    @extend .ljb-flex-row;
    justify-content: space-between;
  }
  .quite-item{
    @extend .ljb-flex-row;
    align-items: center;
  }
  .quite-text{
    font-size: 16px;
    line-height: 16px;
    vertical-align:bottom;
    @extend .ljb-title
  }
  .quite-img{
    width: 18px;
    height: 18px;
  }
  .quite-tag{
    font-size: 12px;
    height: 16px;
    color: white;
    line-height: 16px;
    background: linear-gradient(to right,rgb(249,198,62),rgb(255,114,31)); /* 标准的语法 */
    border-radius: 8px 8px 8px 0;
    padding: 0 6px;
    margin-left: 8px;
    @extend .ljb-md-text;
    @extend .ljb-flex-row;
    @extend .ljb-double-center;
  }
  .van-swipe-change{
    // /deep/.van-swipe__track{
    //   height: 152px !important;
    // }
    .custom-indicator{
      width: 100%;
      font-size: 0;
      text-align: center;
      margin-top: 10px;
      >div{
        display: inline-block;
        width: 18px;
        height: 4px;
        background: #F0F0F0;
        border-radius: 2px 0 0 2px;
      }
      .indicators-active{
        width: 18px;
        height: 4px;
        background: #B98727;
        border-radius: 2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/list/ListField.vue